import request from '@/router/axios'

const eventBase = '/api/produce/emergency-event'
const planBase = '/api/produce/emergency-plan'

export const getList = (data) => {
  return request({
    url: `${eventBase}/select/page`,
    method: 'post',
    data
  })
}

export const report = (data) => {
  return request({
    url: `${eventBase}/report`,
    method: 'post',
    data
  })
}

export const update = (data) => {
  return request({
    url: `${eventBase}/update`,
    method: 'post',
    data
  })
}

export const getDetail = (eventId) => {
  return request({
    url: `${eventBase}/getDetail`,
    method: 'get',
    params: { eventId }
  })
}

export const remove = (id) => {
  return request({
    url: `${eventBase}/delete/id`,
    method: 'get',
    params: { id }
  })
}

export const reportToAuthority = (data) => {
  return request({
    url: `${eventBase}/reportToAuthority`,
    method: 'post',
    data
  })
}

export const startResponse = (data) => {
  return request({
    url: `${eventBase}/startResponse`,
    method: 'post',
    data
  })
}

export const manualEnd = (data) => {
  return request({
    url: `${eventBase}/manualEnd`,
    method: 'post',
    data
  })
}

export const markFalseAlarm = (data) => {
  return request({
    url: `${eventBase}/markFalseAlarm`,
    method: 'post',
    data
  })
}

export const getPlanList = (data) => {
  return request({
    url: `${planBase}/select/distinct/page`,
    method: 'post',
    data
  })
}
